<template>
  <div>
    <Modal v-model="editLogisticsModal" :title="$t('key1006005')" :width="editLogisticsType === 'detailsType' ? 500 : 900"
      :class-name="editLogisticsType === 'listType' ? 'commonModalStyles' : ''"
      :transfer="false" :mask-closable="false" @on-visible-change="editLogisticsModalChange">
      <!--平台订单详情匹配物流-->
      <template v-if="editLogisticsType === 'detailsType'">
        <Form ref="editLogisticsForm" :model="editLogisticsForm" :label-width="110" @submit.native.prevent>
          <Row style="width: 80%;">
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1006006')" prop="ymsLogisServiceId" :rules="{required: true, message: $t('key1001359'),trigger: 'change'}">
                <Select :placeholder="$t('key1001359')" v-model="editLogisticsForm.ymsLogisServiceId" filterable @on-change="selectChange">
                  <OptionGroup v-for="(item,index) in logisticsModeData" :label="item.title" :key="index">
                    <Option v-for="(ele,idx) in item.list" :value="ele.ymsLogisServiceId" :key="idx">{{ ele.name }}</Option>
                  </OptionGroup>
                </Select>
              </FormItem>
              <div class="font-size-12 mt10 mb10 ml50" v-if="editLogisticsType === 'detailsType'&& !customsClearanceFees &&
           (editLogisticsForm.ymsLogisServiceId && !editLogisticsForm.ymsLogisServiceId.includes('CID')) && iossTalg">
                <span>{{ $t('key1006008') }}</span>
                <span class="distributorThemeColor ml5 mr5">{{ iossLogisticCost + ' ' + currencyState }}</span>
                <span>{{ $t('key1006009') }}</span>
              </div>
            </Col>
          </Row>
        </Form>
      </template>
      <!--平台订单列表匹配物流-->
      <template v-else>
        <div class="matchLogistics_content" v-for="(item, index) in matchLogisticsData">
          <div class="matchLogistics_content_title">
            <p class="font-weight-bold font-size-15 color-333 mr40">{{ item.packageCode }}</p>
            <h2 class="font-weight-bold font-size-15 color-333">{{ $t('key1006007') + item.orderShippingWarehouseName }}</h2>
          </div>
          <div class="flex align-items-center">
            <div>
              <div class="matchLogistics_box" v-for="ele in item.goodList">
                <div class="flex width_370 pr20">
                  <div class="img_box">
                    <img :src="ele.primaryImage" alt="">
                  </div>
                  <div class="ml12" style="flex: 1;">
                    <h2 class="font-size-14 color-333 font-weight-bold ellipsis_1" :title="ele.name">{{ ele.name }}</h2>
                    <p>{{ configCharacters(false) + 'SPU：' + ele.ymsSpu }}</p>
                    <p>{{ configCharacters(false) + 'SKU：' + ele.ymsSku }}</p>
                    <p class="distributorThemeColor">{{ ele.specifications }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex align-items-center" style="flex:1">
              <span class="red-dot">{{ $t('key1006006') }}</span>
              <Select :placeholder="$t('key1001359')" v-model="item.ymsLogisServiceId" filterable style="width:350px;">
                <OptionGroup v-for="talg in item.matchLogisticsList" :label="talg.title">
                  <Option v-for="k in talg.list" :value="k.ymsLogisServiceId">{{ k.name }}</Option>
                </OptionGroup>
              </Select>
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <Button @click="editLogisticsModal = false">{{ $t('key1000112') }}</Button>
        <Button type="primary" @click="editLogisticsBtn" :disabled="editLogisticsType === 'detailsType' && customsClearanceFees">{{ $t('key1000555') }}</Button>
      </template>
    </Modal>
    <!--物流单作废费收取提示弹窗-->
    <collectionOfScrapFeesForLogisticsModal
      ref="collectionOfScrapFeesForLogistics"
      @updateSubmit="updateSubmit"
    ></collectionOfScrapFeesForLogisticsModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {amountHandel, batchAllWarehouseData, getAllMatchingLogisticsData, getIossTaxRateData} from "@/utils/common";
import collectionOfScrapFeesForLogisticsModal from "@/components/common/collectionOfScrapFeesForLogisticsModal.vue";

export default {
  name: 'editLogistics',
  components: {
    collectionOfScrapFeesForLogisticsModal
  },
  mixins: [Mixin],
  data() {
    return {
      editLogisticsModal: false,
      editLogisticsForm: {
        ymsLogisServiceId: null,
        ymsPlatformOrderId: null,
        ymsPlatformOrderPackageRelatedId: null
      },
      logisticsModeData: [],
      editLogisticsType: null,
      customsClearanceFees: true,
      iossLogisticCost: null,
      iossTalg: false,
      matchLogisticsData: [],
      detailsObj: {},
      parameterObj: {},
    };
  },
  methods: {
    // 获取修改YMS物流方式的基础数据
    initEditLogisticsData(data, type, platformOrderDetails) {
      this.iossTalg = false;
      this.editLogisticsType = type;
      this.detailsObj = JSON.parse(JSON.stringify(data));
      if (type === 'detailsType') {
        this.editLogisticsForm.ymsPlatformOrderId = data.ymsPlatformOrderId;
        this.editLogisticsForm.ymsPlatformOrderShippingId = data.ymsPlatformOrderShippingId || null;
        if (data.ymsPlatformOrderPackageRelatedId) {
          this.editLogisticsForm.ymsPlatformOrderPackageRelatedId = data.ymsPlatformOrderPackageRelatedId;
        } else {
          let ymsPlatformOrderPackageRelateds = platformOrderDetails.ymsPlatformOrderPackageRelateds || [];
          ymsPlatformOrderPackageRelateds.map((item) => {
            if (item.ymsPlatformOrderShippingId === data.ymsPlatformOrderShippingId) {
              this.editLogisticsForm.ymsPlatformOrderPackageRelatedId = item.ymsPlatformOrderPackageRelatedId;
            }
          });
        }
        let countryCode = data.ymsPackageInfo.buyerCountryCode;
        this.logisticsModeData = data.logisticsModeData || [];
        getIossTaxRateData('distributor').then((newData) => {
          if (newData.length > 0) {
            newData.map((item) => {
              // YMS订单目的国是配置IOSS国家内，且无IOSS号，更换物流需要收取清关费用
              if (item.countryCode === countryCode && !data.iossNo) {
                this.iossTalg = true;
              }
            });
          }
        });
        this.editLogisticsModal = true;
      } else {
        this.editLogisticsForm.ymsPlatformOrderId = data.ymsPlatformOrderId;
        this.handleMatchLogisticsData(data);
      }
    },
    // 处理平台订单的货品数据
    handleMatchLogisticsData(obj) {
      let ymsProductGoodsIds = [];
      let ymsWarehouseIds = [];
      let list = [];
      let newData = [];
      let ymsPlatformOrderShippings = obj.ymsPlatformOrderShippings || [];
      let arr = ymsPlatformOrderShippings.filter((item) => item.status !== 8);
      arr.map((item) => {
        let ymsPlatformOrderShippingDetails = item.ymsPlatformOrderShippingDetails || [];
        ymsPlatformOrderShippingDetails.map((ele) => {
          ele.ymsProductGoodsId = ele.businessId;
          if (ele.ymsProductGoodsId) {
            ymsProductGoodsIds.push(ele.ymsProductGoodsId);
          }
          if (item.ymsWarehouseId) {
            ymsWarehouseIds.push(item.ymsWarehouseId);
          }
          newData.push({
            ymsWarehouseId: item.ymsWarehouseId,
            packageCode: item.packageCode,
            ...ele,
          });
        });
      });

      ymsWarehouseIds = this.uniqueFunc(ymsWarehouseIds);
      ymsProductGoodsIds = this.uniqueFunc(ymsProductGoodsIds);
      let query = {
        warehouseIds: ymsWarehouseIds
      }
      if (this.detailsObj.orderTag === 'TIKTOK_CBT') {
        query.performanceType = 2;
      }
      getAllMatchingLogisticsData(query).then((logisticsData) => {
        if (ymsProductGoodsIds.length > 0) {
          this.getProductInfoByIds(ymsProductGoodsIds, newData, false, false, false).then((newList) => {
            if (newList.length > 0) {
              newList.map((item) => {
                const _productInfo = item._productInfo;
                if (_productInfo) {
                  let specificationsList = [];
                  let {_spuInfo, ymsSku, productGoodsSpecificationList} = _productInfo;
                  let {ymsProductId, name, ymsSpu} = _spuInfo;
                  if (productGoodsSpecificationList.length > 0) {
                    specificationsList = productGoodsSpecificationList.map((item) => {
                      return item.value;
                    });
                  }
                  let specifications = specificationsList.join(' • ');
                  let matchLogisticsList = [];
                  logisticsData.map((k) => {
                    if (k.ymsWarehouseId === item.ymsWarehouseId) {
                      matchLogisticsList = k.logisticsData;
                    }
                  });
                  let skuImgPath = _productInfo.primaryImage;
                  let spuImgPath = _spuInfo.primaryImage;
                  let primaryImage = skuImgPath ? skuImgPath : spuImgPath;
                  list.push({
                    ...item,
                    ymsProductId,
                    name,
                    primaryImage,
                    ymsSpu,
                    ymsSku,
                    specifications,
                    ymsLogisServiceId: null,
                    orderShippingWarehouseName: '',
                    matchLogisticsList: matchLogisticsList
                  });
                }
              });
              const ymsWarehouseIds = list.map(item => item.ymsWarehouseId).filter(Boolean);
              if (!ymsWarehouseIds.length) {
                let newList = this.handerGrouping(list, function (item) {
                  return [item.ymsPlatformOrderShippingId];
                }, ['ymsPlatformOrderShippingId', 'orderShippingWarehouseName', 'ymsWarehouseId', 'ymsPlatformOrderId',
                  'packageCode', 'ymsLogisServiceId', 'matchLogisticsList'], 'goodList');
                this.matchLogisticsData = newList;
                return;
              }
              batchAllWarehouseData(ymsWarehouseIds).then(ymsWarehouseData => {
                const warehouseMap = {};
                ymsWarehouseData.forEach(warehouse => {
                  warehouseMap[warehouse.ymsWarehouseId] = warehouse.name;
                });
                list = list.map(item => ({
                  ...item,
                  orderShippingWarehouseName: warehouseMap[item.ymsWarehouseId] || ''
                }));
                let newList = this.handerGrouping(list, function (item) {
                  return [item.ymsPlatformOrderShippingId];
                }, ['ymsPlatformOrderShippingId', 'orderShippingWarehouseName', 'ymsWarehouseId', 'ymsPlatformOrderId',
                  'packageCode', 'ymsLogisServiceId', 'matchLogisticsList'], 'goodList');
                this.matchLogisticsData = newList;
              });
            }
          });
        }
        this.editLogisticsModal = true;
      });
    },
    // 修改物流信息的保存按钮
    editLogisticsBtn() {
      let v = this;
      let url = '';
      let query = {};
      switch (v.editLogisticsType) {
        // 平台订单详情--匹配物流
        case 'detailsType':
          v.$refs['editLogisticsForm'].validate((valid) => {
            if (valid) {
              let ymsLogisServiceId = v.editLogisticsForm.ymsLogisServiceId;
              /*url = api.put_ymsDistributorPackageInfo_updateOrderCarrierInfo;*/
              url = api.put_ymsPlatformOrder_updateOrderCarrierInfo;
              let {ymsPlatformOrderPackageRelatedId, ...obj} = v.editLogisticsForm;
              query = JSON.parse(JSON.stringify(obj));
              /* query.iossLogisticCost = v.iossLogisticCost;
               query.iossNo = null;*/
              query.carrierMerchantId = null;
              query.carrierMerchantType = null;
              /* query.iossType = 2; // 物流代缴*/
              v.logisticsModeData.map((item) => {
                item.list.map((ele) => {
                  if (ele.ymsLogisServiceId === ymsLogisServiceId) {
                    if (ymsLogisServiceId.indexOf('CID') === 0) {
                      query.carrierId = ele.carrierId;
                      query.shippingMethodId = ele.shippingMethodId;
                      query.ymsLogisServiceId = null;
                    } else {
                      query.carrierId = null;
                      query.shippingMethodId = null;
                      query.ymsLogisServiceId = ymsLogisServiceId;
                    }
                    query.carrierMerchantType = ele.carrierMerchantType;
                    query.carrierMerchantId = ele.merchantId;
                  }
                });
              });
              v.handleData(url, [query]);
            }
          });
          break;
        // 平台订单列表--匹配物流
        case 'listType':
          let list = [];
          url = api.put_ymsPlatformOrder_updateOrderCarrierInfo;
          if (v.matchLogisticsData.length > 0) {
            const allValid = v.matchLogisticsData.every(item => item.ymsLogisServiceId !== null || item.ymsLogisServiceId !== '');
            if (allValid) {
              v.matchLogisticsData.map((item) => {
                let newList = [];
                let obj = {
                  carrierId: null,
                  carrierMerchantId: null,
                  carrierMerchantType: 0, // 物流归属商户 1 供应商 2 分销商 3 运营
                  shippingMethodId: null,
                  ymsLogisServiceId: null,
                  ymsPlatformOrderId: item.ymsPlatformOrderId,
                  ymsPlatformOrderShippingId: item.ymsPlatformOrderShippingId
                };
                item.matchLogisticsList.map((ele) => {
                  newList.push(...ele.list);
                });
                if (newList.length > 0) {
                  newList.map((talg) => {
                    if (talg.ymsLogisServiceId === item.ymsLogisServiceId) {
                      if (item.ymsLogisServiceId.indexOf('CID') === 0) {
                        obj.carrierId = talg.carrierId;
                        obj.shippingMethodId = talg.shippingMethodId;
                        obj.ymsLogisServiceId = null;
                      } else {
                        obj.carrierId = null;
                        obj.shippingMethodId = null;
                        obj.ymsLogisServiceId = talg.ymsLogisServiceId;
                      }
                      obj.carrierMerchantType = talg.carrierMerchantType;
                      obj.carrierMerchantId = talg.merchantId;
                    }
                  });
                }
                list.push(obj);
              });
              v.saveData(url, list);
            } else {
              v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006004'));
              return false;
            }
          }
          break;
      }
    },
    // 物流单作废费收取
    handleData(url, query) {
      if (this.detailsObj.ymsPackageInfo.providerName) {
        let obj = {
          totalPrice: this.detailsObj.ymsPackageInfo.totalPrice,
          trackingNumberTime: this.detailsObj.ymsPackageInfo.trackingNumberTime,
          ymsPackageId: this.detailsObj.ymsPackageInfo.ymsPackageId,
        };
        this.parameterObj = {
          url,
          query
        };
        this.$refs['collectionOfScrapFeesForLogistics'].initCollectionOfScrapFeesForLogisticsData(obj).then((value) => {
          if (!value) {
            this.saveData(url, query);
          }
        });
      } else {
        this.saveData(url, query);
      }
    },
    // 处理保存数据
    saveData(url, query) {
      let v = this;
      v.axios.put(url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
          v.editLogisticsModal = false;
          v.$emit('updateData', true);
        }
      });
    },
    // 回调方法
    updateSubmit() {
      let {url, query} = this.parameterObj;
      this.saveData(url, query);
    },
    // 选择物流
    selectChange(val) {
      let v = this;
      v.iossLogisticCost = 0;
      v.customsClearanceFees = true;
      if (v.editLogisticsType === 'detailsType') {
        if (val) {
          // 只有YMS物流的才计算清关费用
          if (!val.includes('CID') && v.iossTalg) {
            let query = {
              ymsPlatformOrderId: v.editLogisticsForm.ymsPlatformOrderId,
              ymsPlatformOrderPackageRelatedId: v.editLogisticsForm.ymsPlatformOrderPackageRelatedId,
              ymsLogisServiceId: val
            };
            v.axios.post(api.post_ymsPlatformOrder_getIOSSLogisticCost, query, {loading: true}).then(response => {
              if (response.data.code === 0) {
                let data = response.data.datas || 0;
                if (data) {
                  v.iossLogisticCost = amountHandel(data);
                }
                v.customsClearanceFees = false;
              }
            });
          } else {
            v.customsClearanceFees = false;
          }
        }
      }
    },
    // 展开选择匹配物流下拉框
    openChange(value, obj, index) {
      let ymsWarehouseId = obj.ymsWarehouseId;
      let matchLogisticsList = obj.matchLogisticsList || [];
      if (value && matchLogisticsList.length <= 0) {
        getAllMatchingLogisticsData({warehouseIds: [ymsWarehouseId]}).then((newList) => {
          newList.map((item) => {
            if (item.ymsWarehouseId === ymsWarehouseId) {
              let logisticsData = item.logisticsData;
              this.$set(this.matchLogisticsData[index], 'matchLogisticsList', logisticsData);
              this.$forceUpdate();
            }
          });
        });
      }
    },
    // 监听弹窗
    editLogisticsModalChange(value) {
      let v = this;
      if (!value) {
        v.$nextTick(() => {
          if (v.editLogisticsType === 'detailsType') {
            v.$refs['editLogisticsForm'].resetFields();
          }
        });
        v.iossTalg = false;
        v.customsClearanceFees = true;
        v.matchLogisticsData = [];
        v.logisticsModeData = [];
        v.detailsObj = {};
        v.parameterObj = {};
      }
    },
  }
};
</script>

<style lang="less" scoped>
.commonModalStyles {
  .matchLogistics_content {
    margin-bottom: 24px;

    .matchLogistics_content_title {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #E2E2E2;
      padding-bottom: 8px;
    }

    .matchLogistics_box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 0;

      .img_box {
        width: 80px;
        height: 80px;
        position: relative;

        img {
          display: inline-block;
          left: 50%;
          max-height: 100%;
          max-width: 100%;
          position: absolute;
          top: 50%;
          transform: translateY(-50%) translateX(-50%);
        }
      }

      /*&:last-child {
        margin-bottom: 0;
        padding-bottom: 0;
      }*/
    }
  }
}
</style>
